import type { ISubscriptionInfo } from "@/account/account-models";
import { createAction } from "@reduxjs/toolkit";
import type {
  IGetBroadcastStatsConfig,
  IGetPayoutsConfig,
  IGetReferrersConfig,
  IGetSubscribersConfig,
  IGetUserStatsConfig,
} from "./earnings-action-creators";
import type {
  IGetEarningsListResponse,
  IGetPayoutsResponse,
  IGetReferrersResponse,
} from "./earnings-api";
import type { IBroadcastStatsItem, IUserStatsItem } from "./earnings-models";

interface SuccessPayload<TResponse, TConfig> {
  res: TResponse;
  config: TConfig;
}

export namespace IEarningsActions {
  export enum Type {
    GET__PAYOUTS__SUCCESS = "GET__PAYOUTS__SUCCESS",

    GET__SUBSCRIBERS__SUCCESS = "GET__SUBSCRIBERS__SUCCESS",

    GET__REFERRERS__SUCCESS = "GET__REFERRERS__SUCCESS",

    GET__BROADCAST_STATS__SUCCESS = "GET__BROADCAST_STATS__SUCCESS",

    GET__USER_STATS__SUCCESS = "GET__USER_STATS__SUCCESS",

    // GET__PAYOUT_BANKS__INIT = 'GET__PAYOUT_BANKS__INIT',
    // GET__PAYOUT_BANKS__SUCCESS = 'GET__PAYOUT_BANKS__SUCCESS',
    // GET__PAYOUT_BANKS__FAILURE = 'GET__PAYOUT_BANKS__FAILURE',

    // POST__PAYOUT_BANK__INIT = 'POST__PAYOUT_BANK__INIT',
    // POST__PAYOUT_BANK__SUCCESS = 'POST__PAYOUT_BANK__SUCCESS',
    // POST__PAYOUT_BANK__FAILURE = 'POST__PAYOUT_BANK__FAILURE',

    // PUT__PAYOUT_BANK__INIT = 'PUT__PAYOUT_BANK__INIT',
    // PUT__PAYOUT_BANK__SUCCESS = 'PUT__PAYOUT_BANK__SUCCESS',
    // PUT__PAYOUT_BANK__FAILURE = 'PUT__PAYOUT_BANK__FAILURE',

    // DELETE__PAYOUT_BANK__INIT = 'DELETE__PAYOUT_BANK__INIT',
    // DELETE__PAYOUT_BANK__SUCCESS = 'DELETE__PAYOUT_BANK__SUCCESS',
    // DELETE__PAYOUT_BANK__FAILURE = 'DELETE__PAYOUT_BANK__FAILURE'
  }
  export const successGetPayouts = createAction<
    SuccessPayload<IGetPayoutsResponse, IGetPayoutsConfig>
  >(Type.GET__PAYOUTS__SUCCESS);

  export const successGetSubscribers = createAction<
    SuccessPayload<
      IGetEarningsListResponse<ISubscriptionInfo>,
      IGetSubscribersConfig
    >
  >(Type.GET__SUBSCRIBERS__SUCCESS);

  export const successGetReferrers = createAction<
    SuccessPayload<IGetReferrersResponse, IGetReferrersConfig>
  >(Type.GET__REFERRERS__SUCCESS);

  export const successGetBroadcastStats = createAction<
    SuccessPayload<
      IGetEarningsListResponse<IBroadcastStatsItem>,
      IGetBroadcastStatsConfig
    >
  >(Type.GET__BROADCAST_STATS__SUCCESS);

  export const successGetUserStats = createAction<
    SuccessPayload<
      IGetEarningsListResponse<IUserStatsItem>,
      IGetUserStatsConfig
    >
  >(Type.GET__USER_STATS__SUCCESS);
}

export type EarningsActions = Omit<typeof IEarningsActions, "Type">;
